import { BaseEncoder } from "./BaseEncoder";
import { BaseObjectEncoder } from "./BaseObjectEncoder";
import { DefaultBaseObjectEncoderImpl } from "./DefaultBaseObjectEncoderImpl";

import { InflightCheckEventImpl } from "../model/impl/InflightCheckEventImpl";
import { Encodable } from "../model/Encodable";

import * as CubiqTS from "../index";

export class InflightCheckEventImplEncoder implements BaseEncoder {
  public baseEncoder: BaseObjectEncoder = new DefaultBaseObjectEncoderImpl();

  private static _instance;

  private constructor() {}

  public static get Instance() {
    // Do you need arguments? Make it a regular method instead.
    return this._instance || (this._instance = new this());
  }

  public encode(encodable: InflightCheckEventImpl, streamout: CubiqTS.ByteBuffer): void {
    this.baseEncoder.encode(encodable, streamout);

    this.baseEncoder.writeStartEncoding(streamout);

    /*Object encoding*/
    if (encodable.ruleId != null) {
      this.baseEncoder.writeStartFid(1, streamout);
      this.baseEncoder.writeObject(
        false,
        InflightCheckEventImplEncoder.fidTypeMap.get(1),
        false,
        encodable.ruleId,
        streamout,
      );
      this.baseEncoder.writeEndFid(1, streamout);
    }
    /*Object encoding*/
    if (encodable.ruleName != null) {
      this.baseEncoder.writeStartFid(2, streamout);
      this.baseEncoder.writeObject(
        false,
        InflightCheckEventImplEncoder.fidTypeMap.get(2),
        false,
        encodable.ruleName,
        streamout,
      );
      this.baseEncoder.writeEndFid(2, streamout);
    }
    /*Object encoding*/
    if (encodable.ruleType != null) {
      this.baseEncoder.writeStartFid(3, streamout);
      this.baseEncoder.writeObject(
        false,
        InflightCheckEventImplEncoder.fidTypeMap.get(3),
        false,
        encodable.ruleType,
        streamout,
      );
      this.baseEncoder.writeEndFid(3, streamout);
    }
    /*Object encoding*/
    if (encodable.ruleRangeValue != null) {
      this.baseEncoder.writeStartFid(4, streamout);
      this.baseEncoder.writeObject(
        false,
        InflightCheckEventImplEncoder.fidTypeMap.get(4),
        false,
        encodable.ruleRangeValue,
        streamout,
      );
      this.baseEncoder.writeEndFid(4, streamout);
    }
    /*Object encoding*/
    if (encodable.ruleRateUnits != null) {
      this.baseEncoder.writeStartFid(5, streamout);
      this.baseEncoder.writeObject(
        false,
        InflightCheckEventImplEncoder.fidTypeMap.get(5),
        false,
        encodable.ruleRateUnits,
        streamout,
      );
      this.baseEncoder.writeEndFid(5, streamout);
    }
    /*Object encoding*/
    if (encodable.isCancelOutrightFg != null) {
      this.baseEncoder.writeStartFid(6, streamout);
      this.baseEncoder.writeObject(
        false,
        InflightCheckEventImplEncoder.fidTypeMap.get(6),
        false,
        encodable.isCancelOutrightFg,
        streamout,
      );
      this.baseEncoder.writeEndFid(6, streamout);
    }
    /*Object encoding*/
    if (encodable.alternateTraderGroup != null) {
      this.baseEncoder.writeStartFid(7, streamout);
      this.baseEncoder.writeObject(
        false,
        InflightCheckEventImplEncoder.fidTypeMap.get(7),
        true,
        encodable.alternateTraderGroup,
        streamout,
      );
      this.baseEncoder.writeEndFid(7, streamout);
    }
    /*Object encoding*/
    if (encodable.actionType != null) {
      this.baseEncoder.writeStartFid(8, streamout);
      this.baseEncoder.writeObject(
        false,
        InflightCheckEventImplEncoder.fidTypeMap.get(8),
        false,
        encodable.actionType,
        streamout,
      );
      this.baseEncoder.writeEndFid(8, streamout);
    }
    /*Object encoding*/
    if (encodable.orderData != null) {
      this.baseEncoder.writeStartFid(9, streamout);
      this.baseEncoder.writeObject(
        false,
        InflightCheckEventImplEncoder.fidTypeMap.get(9),
        true,
        encodable.orderData,
        streamout,
      );
      this.baseEncoder.writeEndFid(9, streamout);
    }
    /*Object encoding*/
    if (encodable.messageId != null) {
      this.baseEncoder.writeStartFid(100, streamout);
      this.baseEncoder.writeObject(
        false,
        InflightCheckEventImplEncoder.fidTypeMap.get(100),
        false,
        encodable.messageId,
        streamout,
      );
      this.baseEncoder.writeEndFid(100, streamout);
    }
    /*Object encoding*/
    if(encodable.sessionOnly!=null){
        this.baseEncoder.writeStartFid(10010,streamout);
        this.baseEncoder.writeObject(false,InflightCheckEventImplEncoder.fidTypeMap.get(10010),false,encodable.sessionOnly,streamout);
        this.baseEncoder.writeEndFid(10010,streamout);
    }
    this.baseEncoder.writeEndEncoding(streamout);
  }

  static fidTypeMap: Map<number, string> = new Map<number, string>([
    [1, "java.lang.Long"],
    [2, "java.lang.String"],
    [3, "com.bcdfx.model.InflightRuleType"],
    [4, "java.lang.String"],
    [5, "java.lang.String"],
    [6, "java.lang.Boolean"],
    [7, "com.bcdfx.model.TradingGroup"],
    [8, "com.bcdfx.model.InflightActionType"],
    [9, "com.bcdfx.model.event.lifecycle.fx.OrderData"],
    [100, "java.lang.String"],
    [10010, "java.lang.String"],
  ]);

  /**
   * Constructs the event from a given byte stream
   */
  public decode(encodable: InflightCheckEventImpl, streamin: CubiqTS.ByteBuffer): void {
    this.baseEncoder.decode(encodable, streamin);

    while (true) {
      let ct: string = this.baseEncoder.readCtrl(streamin);
      if (ct == "^F") {
        break;
      }
      if (ct == "^H") continue;
      let fid: number = this.baseEncoder.parseCtrlAsFid(ct);
      if (this.supportsFid(fid) == false) this.baseEncoder.seekToNextFid(fid, streamin);
      switch (fid) {
        case 1: {
          /*Object encoding*/
          let val: CubiqTS.Long = this.baseEncoder.readObject(
            false,
            false,
            InflightCheckEventImplEncoder.fidTypeMap.get(1),
            streamin,
          );
          encodable.ruleId = <CubiqTS.Long>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 2: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            InflightCheckEventImplEncoder.fidTypeMap.get(2),
            streamin,
          );
          encodable.ruleName = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 3: {
          /*Object encoding*/
          let val: CubiqTS.InflightRuleType = this.baseEncoder.readObject(
            false,
            false,
            InflightCheckEventImplEncoder.fidTypeMap.get(3),
            streamin,
          );
          encodable.ruleType = <CubiqTS.InflightRuleType>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 4: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            InflightCheckEventImplEncoder.fidTypeMap.get(4),
            streamin,
          );
          encodable.ruleRangeValue = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 5: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            InflightCheckEventImplEncoder.fidTypeMap.get(5),
            streamin,
          );
          encodable.ruleRateUnits = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 6: {
          /*Object encoding*/
          let val: boolean = this.baseEncoder.readObject(
            false,
            false,
            InflightCheckEventImplEncoder.fidTypeMap.get(6),
            streamin,
          );
          encodable.isCancelOutrightFg = <boolean>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 7: {
          /*Object encoding*/
          let val: CubiqTS.TradingGroup = this.baseEncoder.readObject(
            true,
            false,
            InflightCheckEventImplEncoder.fidTypeMap.get(7),
            streamin,
          );
          encodable.alternateTraderGroup = <CubiqTS.TradingGroup>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 8: {
          /*Object encoding*/
          let val: CubiqTS.InflightActionType = this.baseEncoder.readObject(
            false,
            false,
            InflightCheckEventImplEncoder.fidTypeMap.get(8),
            streamin,
          );
          encodable.actionType = <CubiqTS.InflightActionType>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 9: {
          /*Object encoding*/
          let val: CubiqTS.OrderData = this.baseEncoder.readObject(
            true,
            false,
            InflightCheckEventImplEncoder.fidTypeMap.get(9),
            streamin,
          );
          encodable.orderData = <CubiqTS.OrderData>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 100: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            InflightCheckEventImplEncoder.fidTypeMap.get(100),
            streamin,
          );
          encodable.messageId = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 10010:
        {
            /*Object encoding*/
            let val_10010:string=this.baseEncoder.readObject(false,false,InflightCheckEventImplEncoder.fidTypeMap.get(10010),streamin);
            encodable.sessionOnly=val_10010;
            this.baseEncoder.readEndFid(streamin);
            break;
        }
      }
    }
  }

  private supportsFid(fid: number): boolean {
    return InflightCheckEventImplEncoder.fidTypeMap.has(fid);
  }
}
